import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as addressActions from 'redux/actions/address';
import * as addressSelectors from 'redux/selectors/address';
import * as cartActions from 'redux/actions/cart';
import * as cartSelectors from 'redux/selectors/cart';
import * as checkoutActions from 'redux/actions/checkout';
import * as checkoutSelectors from 'redux/selectors/checkout';
import CheckoutSteps from 'pages/Checkout/steps';
import { Row, Col, Form, Radio, Button, Alert, Modal } from 'antd';
import { CartSummary, AddressForm } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withEventBus, withScreenLoader } from 'context';
import { ADDRESS_SAVED } from 'redux/actions/address/action_types';
import { CHECKOUT_SHIPPING_METHOD_UPDATED } from 'redux/actions/checkout/action_types';
import { CART_LOADED } from 'redux/actions/cart/action_types';
import styles from './shipping.module.less';
import cstyles from '../checkout.module.less';

class Shipping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddressForm: false,
      address: { id: 0 }
    };
    this.subscriptions = [];
  }

  componentDidMount() {
    this.props.loadCart();
    this.props.loadAddresses();
    this.props.loadShippingMethods();
    this.props.showScreenLoader();
    this.subscriptions.push(
      this.props.eventBusSubscribe(ADDRESS_SAVED, () => {
        this.toggleAddressForm();
        this.props.loadAddresses();
      })
    );
    this.subscriptions.push(
      this.props.eventBusSubscribe(CHECKOUT_SHIPPING_METHOD_UPDATED, () => {
        this.props.hideScreenLoader();
        this.props.history.push('/checkout/payment');
      })
    );
    this.subscriptions.push(
      this.props.eventBusSubscribe(CART_LOADED, () => {
        this.props.hideScreenLoader();
      })
    );
  }

  componentWillUnmount() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.props.unloadCart();
    this.props.unloadAddresses();
    this.props.unloadCheckout();
  }

  toggleAddressForm = () => {
    this.setState((state, props) => ({
      showAddressForm: !state.showAddressForm
    }));
  };

  saveNewAddress = add => {
    this.props.saveAddress(add);
  };

  render() {
    return (
      <div className="cuiContentWrapper">
        <div className={styles.shippingCheckout}>
          <Row gutter={24}>
            <Col span={18}>
              <CheckoutSteps current={0} />
              <WrappedShippingForm
                addresses={this.props.addresses}
                cart={this.props.cart}
                shippingMethods={this.props.shippingMethods}
                updateShippingMethod={this.props.updateShippingMethod}
                addNewAddress={this.toggleAddressForm}
                showScreenLoader={this.props.showScreenLoader}
              />
            </Col>
            <Col span={6}>
              <CartSummary cart={this.props.cart} showCheckoutBtn={false} />
            </Col>
          </Row>
          <Modal
            title="Add new address"
            centered
            visible={this.state.showAddressForm}
            footer={null}
            onCancel={this.toggleAddressForm}
            width="850px"
            destroyOnClose={true}
          >
            <AddressForm
              data={this.state.address}
              loadProvinces={this.props.loadProvinces}
              provinces={this.props.provinces}
              saveAddress={this.saveNewAddress}
            />
          </Modal>
        </div>
      </div>
    );
  }
}

class ShippingForm extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.showScreenLoader();
        this.props.updateShippingMethod(values);
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form className={styles.shippingForm} onSubmit={this.handleSubmit}>
        <h3 className={cstyles.sectionHeading}>Shipping Address</h3>
        <Form.Item className={styles.addressItem}>
          {getFieldDecorator('addressId', {
            initialValue: this.props.cart.shippingAddress != null ? this.props.cart.shippingAddress.id : null,
            rules: [{ required: true, message: 'Please select a shipping address or add new address.' }]
          })(
            <Radio.Group className={styles.addressRadioGroup}>
              {this.props.addresses.map(add => (
                <Radio value={add.id} key={add.id} className={styles.addressRadio}>
                  <div className={styles.addContainer}>
                    <span className={styles.addName}>{add.name}</span>
                    {add.company && <span className={styles.addLine}>{add.company}</span>}
                    <span className={styles.addLine}>{add.street1}</span>
                    {add.street2 && <span className={styles.addLine}>{add.street2}</span>}
                    <span className={styles.addLine}>
                      {add.city}, {add.province} {add.postalCode}
                    </span>
                    {add.phoneNo && <span className={styles.addLine}>{add.phoneNo}</span>}
                    <FontAwesomeIcon icon="check-square" className={styles.addSelectedIcon} />
                  </div>
                </Radio>
              ))}
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item className={styles.addNewAddBtnContainer}>
          <Button onClick={this.props.addNewAddress}>Add New</Button>
        </Form.Item>
        <h3 className={cstyles.sectionHeading}>Shipping Method</h3>
        <Alert
          className={styles.shippingAlert}
          description={
            'Shipping charges will be added after order is processed. Your order will be processed ' +
            'within 24 working hours. Orders placed after 2:00 pm EST will be processed next working day.'
          }
          type="info"
        />
        <Form.Item className={styles.methodItem}>
          {getFieldDecorator('method', {
            initialValue: null,
            rules: [{ required: true, message: 'Please select a shipping method.' }]
          })(
            <Radio.Group className={styles.methodRadioGroup}>
              {this.props.shippingMethods.map(m => (
                <Radio value={m.id} key={m.id} className={styles.methodRadio}>
                  <span className={styles.methodName}>{m.name}</span>
                  <span className={styles.methodDesc}>{m.description}</span>
                  <span className={styles.methodCharges}>Charges will be added later</span>
                </Radio>
              ))}
            </Radio.Group>
          )}
        </Form.Item>
        <div className={cstyles.actionBtnContainer}>
          <Button className={cstyles.nextBtn} htmlType="submit" type="primary" size="large">
            Next
          </Button>
        </div>
      </Form>
    );
  }
}

const WrappedShippingForm = Form.create({ name: 'shippingCheckoutForm' })(ShippingForm);

const mapDispatchToProps = {
  loadAddresses: addressActions.load,
  loadProvinces: addressActions.loadProvinces,
  unloadAddresses: addressActions.unload,
  loadCart: cartActions.load,
  unloadCart: cartActions.unload,
  loadShippingMethods: checkoutActions.loadShippingMethods,
  unloadCheckout: checkoutActions.unload,
  updateShippingMethod: checkoutActions.updateShippingMethod,
  saveAddress: addressActions.save
};

const mapStateToProps = (state, ownProps) => ({
  addresses: addressSelectors.getAddresses(state),
  provinces: addressSelectors.getProvinces(state),
  cart: cartSelectors.getFullCart(state),
  shippingMethods: checkoutSelectors.getShippingMethods(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withScreenLoader(withEventBus(withRouter(Shipping))));
